<template>
<!-- v-if="params.data.isactive == 'Active' && params.data.status == 'Paid'" -->
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ params.value }}</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (value === true) return 'success'


        else if (value === 'Paid') return 'success'
        else if (value === 'Inactive') return ''
        else if (value === 'Pending Payment') return 'warning'
        else if (value === 'Waiting confirmation') return 'warning' // Sync Saga: "Ready to be sent to SAGA" not clicked yet
        else if (value === 'Major Issue!') return 'danger'


        else if (value === false) return 'danger'
        else if (value === 'Active') return 'primary'
        else if (value === 'Inactive') return ''
        else if (value === '5/5') return 'success'
        else if (value === '4/5') return 'success'
        else if (value === '3/5') return 'warning'
        else if (value === '2/5') return 'warning'
        else if (value === '1/5') return 'danger'
        else if (value === '0/5') return 'danger'
        else if (value === 'Paid') return 'success'
        else if (value === 'Pending') return 'danger'
        else return ''
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
/*.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}*/
</style>
